import { AsyncOperationsModel } from "../../../../utility/AsyncOperationsModel";
import BaseComponent from "../../../../utility/BaseComponent";
import { observable, action, computed } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { DatePicker, TimePicker, 
    TextField, Card, CardText, DialogContainer, Toolbar, Button, Paper, 
    Radio, Checkbox, SelectField } from "react-md";
import "./static/SendPushNotificationsDialog.scss";
import { IOrganisation, 
    IRole, IGroup, 
    NotificationAppUrlSection, 
    NotificationAppUrlItem, IPushNotification, IUser } from "../../../../model/ModelTypes";
import { isNullOrUndefined } from "util";
import { PushNotificationsOperations, TestingAppUrlItem, CoursesAppUrlItem } 
from "../../../../utility/admin/OrganisationOperations/PushNotificationsOperations/PushNotificationsOperations";
import { Scheduler } from "rxjs";
import { zip } from "rxjs/operators";
import * as moment from 'moment';

export class SendPushNotificationsDialogModel extends AsyncOperationsModel {
    @observable user: IUser;
    @observable showDialog: boolean = false;
    @observable pageX: number = 0;
    @observable pageY: number = 0;
    @observable withSelectedRole: boolean = false;
    onComplete: Function;
    @observable sendLaterEnabled: boolean = false;
    @observable notificationTitle = "";
    @observable notificationBody = "";
    @observable selectedDate = "";
    @observable selectedTime = "";
    @observable selectedRole: IRole;
    @observable selectedGroups: IGroup[] = []; 
    @observable selectedSection = "";
    @observable organisation: IOrganisation;
    @observable generalAppSections: NotificationAppUrlSection[];
    @observable testingAppSections: TestingAppUrlItem[];
    @observable quizgAppSections: TestingAppUrlItem[];
    @observable coursesAppSections: CoursesAppUrlItem[];
    @observable selectedAppUrl: NotificationAppUrlItem;
    @observable selectedCourseCode: string;
    @observable selectedModuleName: string;
    @observable selectedPageName: string;
    @observable selectedTestCourse: string;
    @observable selectedTestModule: string;
    @observable sendDisabled = false;

    @observable sendToAllOrganisations: boolean = false;

    private operations: PushNotificationsOperations;
    // private subscriptions: Subscription;
    @action.bound
    setDialogVisible(flag: boolean) {
        this.showDialog = flag;
    }
    @action.bound
    setPageX(x: number) {
        this.pageX = x;
    }

    @action.bound
    setPageY(y: number) {
        this.pageY = y;
    }
    @action.bound
    resetAsyncOperationsCount() {
        this.asyncOperationsCount = 0;
    }
    @action.bound
    setOrganisation(organisation: IOrganisation) {
        this.organisation = organisation;
        this.resetAsyncOperationsCount();
    }
    @action.bound setAppUrlSections(appUrls: NotificationAppUrlSection[]) {
        this.generalAppSections = appUrls;
    }
    @action.bound setCoursesAppUrls(appUrls: CoursesAppUrlItem[]) {
        this.coursesAppSections = appUrls;
    }
    @action.bound setQuizAppUrlSections(appUrls: TestingAppUrlItem[]) {
        this.quizgAppSections = appUrls;
    }
    @action.bound setTestUrlSections(appUrls: TestingAppUrlItem[]) {
        this.testingAppSections = appUrls;
    }
    @action.bound
    setUser(user: IUser) {
        this.user = user;
    }
    @computed get roles() {
        return this.organisation.roles;
    }
    @computed get groups() {
        return this.organisation.groups;
    }
    @action.bound 
    onRoleSelected(value: string) { 
        let selectedRole = this.organisation.roles.find(item => item.name === value); 
        if (!isNullOrUndefined(selectedRole)) { 
            this.selectedRole = selectedRole; 
        } 
    } 
    @action.bound 
    onGroupSelected(value: string) { 
        let selectedGroup = this.organisation.groups.find(item => item.name === value); 
        if (!isNullOrUndefined(selectedGroup)) { 
            let alreadySelectedIndex = this.selectedGroups.findIndex(item => item.name === selectedGroup.name); 
            if (alreadySelectedIndex > -1) { 
                this.selectedGroups.splice(alreadySelectedIndex, 1); 
            } else { 
                this.selectedGroups.push(selectedGroup); 
            } 
        } 
    } 
    @action.bound 
    onAudienceSelected(value: string) {
        if (value === "everyone") { 
            if (this.withSelectedRole) {
                this.selectedSection = "";
            }
            this.withSelectedRole = false; 
            this.selectedRole = undefined;
            this.selectedGroups = [];

        } else if (value === "roles") { 
            this.withSelectedRole = true; 
        } 
    }
    @action.bound
    onDoneClicked() {
        let sendDate = "";
        if (this.sendLaterEnabled && this.selectedDate === "" && this.selectedTime === "") {
            this.setErrorMessages(["Date and time are required"]);
        } else if (this.sendLaterEnabled) {
            let dateParts = this.selectedDate.split("/");
            if (dateParts.length !== 3) {
                throw Error("Invalid Date");
            }
            let timeParts = this.selectedTime.split(":");
            if (timeParts.length < 2) {
                throw Error("Invalid Time");
            }

            let selectedDateObject = moment().toDate();
            selectedDateObject.setDate(Number(dateParts[0]));
            selectedDateObject.setMonth(Number(dateParts[1]) - 1);
            selectedDateObject.setFullYear(Number(dateParts[2]));
            selectedDateObject.setHours(Number(timeParts[0]));
            selectedDateObject.setMinutes(Number(timeParts[1]));
            if (moment().toDate().getTime() > 
            selectedDateObject.getTime()) {
                this.setErrorMessages(["Notification Date must be in the future"]);
                return;
            }
            sendDate = selectedDateObject.toISOString();
        }
        if (this.organisation.code === "SSPINQ") {
            if (this.sendToAllOrganisations) {
                this.operations.modifyOrganisationCode(this.organisation.parent_code || this.organisation.code);
            } else {
                this.operations.modifyOrganisationCode(this.organisation.code);
            }
        }
        if (this.withSelectedRole && isNullOrUndefined(this.selectedRole)) {
            this.setErrorMessages(["You must select a role"]);
            return;
        }
        if (!isNullOrUndefined(this.notificationBody) && this.notificationBody.length !== 0) {
            let appUrl: string;
            if (this.selectedSection === "Home Page") {
                appUrl = "";
            } else if (!isNullOrUndefined(this.generalAppSections) &&
            this.generalAppSections.map(item => item.name)
            .indexOf(this.selectedSection) > -1  && !isNullOrUndefined(this.selectedAppUrl)) {
                appUrl = this.selectedAppUrl.appUrl;
                if (!isNullOrUndefined(this.selectedAppUrl.extras) && this.selectedAppUrl.extras.length > 0) {
                    let queryParams = "";
                    this.selectedAppUrl.extras.forEach(
                        (item, index) => {
                            if (!isNullOrUndefined(item.value) && !isNullOrUndefined(item.key)) {
                                if (index !== 0) {
                                    queryParams += "&";
                                }
                                queryParams += `${item.key}=${item.value}`;
                            }
                        }
                    );
                    if (queryParams !== "") {
                        appUrl += `?${queryParams}`;
                    }
                }
            }
            if (!isNullOrUndefined(this.coursesAppSections) &&
            this.selectedSection === "Course Page")  {
                let course = this.coursesAppSections.find(item => item.code === this.selectedCourseCode);
                let courseModule = course.courseModules.find(item => item.label === this.selectedModuleName);  
                appUrl = courseModule.appUrl + 
                `/${this.selectedRole.name.replace(/[^0-9a-z]/gi, '')}/${course.label}/${this.selectedPageName}`;
                // .pages.find(item => item.label === this.selectedPageName).appUrlFunction(this.selectedRole.name);
            } else if (!isNullOrUndefined(this.quizgAppSections) &&
                this.selectedSection === "Module Quiz") {
                    appUrl = this.quizgAppSections.find(item => item.label === this.selectedTestCourse)
                    .modules.find(item => item.label === this.selectedTestModule).appUrl;
            } else if (!isNullOrUndefined(this.testingAppSections) &&
            this.selectedSection === "Module Test") {
                appUrl = this.testingAppSections.find(item => item.label === this.selectedTestCourse)
                .modules.find(item => item.label === this.selectedTestModule).appUrl;
            }
            let notification: IPushNotification = {
                user: this.user,
                groups: !isNullOrUndefined(this.selectedGroups) ? this.selectedGroups.map(item => item.name) : [],
                roles: !isNullOrUndefined(this.selectedRole) ? [this.selectedRole.name] : [],
                body: this.notificationBody,
                title: this.notificationTitle,
                app_url: [appUrl],
                created_time: moment().toISOString(),
                sending_time: (sendDate !== "") ? sendDate : undefined
            };
            this.sendDisabled = true;
            this.operations.sendPushNotification(notification)
            .subscribe(
                result => {
                    this.onComplete(notification, this.sendLaterEnabled);
                },
                error => {
                    this.sendDisabled = false;
                    this.setErrorMessages(["Failed to send notifications"]);
                    this.reportError(error);
                }
            );
        }
    }
    constructor(operations: PushNotificationsOperations) {
        super();
        this.asyncOperationsCount = 0;
        this.operations = operations;
    }
    @action.bound 
    setSelectedAppUrl(item: NotificationAppUrlItem) {
        this.selectedAppUrl = item;
    }
    @action.bound
    prepare() {
        this.asyncOperationsCount = 1;
        this.operations.observeOrganisationChanges()
        .pipe(
            zip(
                this.operations.observeAvialableAppUrls(),
                this.operations.observeAvialableCoursesAppUrls(),
                this.operations.observeAvialableQuizAppUrls(),
                this.operations.observeAvialableTestAppUrls(),
                ( organiastion, genericAppUrls, coursesAppUrls, quizzAppUrls, testAppUrls ) => {
                    this.setOrganisation(organiastion);
                    this.setAppUrlSections(genericAppUrls);
                    this.setCoursesAppUrls(coursesAppUrls);
                    this.setQuizAppUrlSections(quizzAppUrls);
                    this.setTestUrlSections(testAppUrls);
                    this.resetAsyncOperationsCount();
                    return true;
                }
            
            )
        )
            .subscribeOn(Scheduler.async)
            .observeOn(Scheduler.async)
            .subscribe(
                undefined,
                error => {
                    this.setErrorMessages(["Failed to fetch organisation information"]);
                    this.resetAsyncOperationsCount();
                    this.reportError(error);
                }
            );
    }

}

@observer class SendPushNotificationsDialog extends BaseComponent<{model: SendPushNotificationsDialogModel}, {}> {
    generalAppUrlsPresenter() {
        let selectedSection = this.props.model
        .generalAppSections.find(item => item.name === this.props.model.selectedSection);
        let items: NotificationAppUrlItem[];
        // if (isNullOrUndefined(this.props.model.selectedRole)) {
        //     items = selectedSection.items.filter(item => item.requiresLogin === "false");
        // } else {
        items = selectedSection.items.filter(item => 
            isNullOrUndefined(item.roles) || 
            item.roles.length === 0 || 
            isNullOrUndefined(this.props.model.selectedRole) ||
            item.roles.findIndex(roleName => roleName === this.props.model.selectedRole.name) !== -1
        );
    
        // }
        return (
            <div className="ItemSubContainer">
                {
                    // !isNullOrUndefined(selectedSection) &&
                    !isNullOrUndefined(items) &&
                    items.length > 0 &&
                    <SelectField
                        id="notificaionItemSelector"
                        label="App Page"
                        placeholder="Select Page"
                        required={true}
                        helpText="Select the page you want to the notification to open on"
                        menuItems={
                            items.map(
                                notificaitonItem => {
                                    return {
                                        label: notificaitonItem.label,
                                        value: notificaitonItem.label
                                    };
                                }
                            )
                        }
                        fullWidth={true}
                        value={!isNullOrUndefined(this.props.model.selectedAppUrl) ?
                             this.props.model.selectedAppUrl.label : undefined }
                        onChange={(value) => {
                            this.props.model
                            .setSelectedAppUrl(
                                selectedSection.items.find( item => item.label === value.toString())
                            );    
                            
                        }}
                    /> 
                }
                {
                    !isNullOrUndefined(this.props.model.selectedAppUrl) &&
                    !isNullOrUndefined(this.props.model.selectedAppUrl.extras) &&
                    this.props.model.selectedAppUrl.extras.map(
                        item => {
                            return (
                                <TextField
                                    key={`${item.label}_extras_input`}
                                    id="extrasInput"
                                    helpText="Details of a specific item on this page that the users should see"
                                    fullWidth={false}
                                    label={
                                        item.label.replace(/\w\S*/g, function(txt: string) {
                                            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                                        })
                                    } 
                                    type="text" 
                                    onChange={(e) => item.value = e.toString()}
                                    value={item.value}
                                />
                            );
                        }
                    )
                }
            </div>
        );
    }
    coursesAppUrlsPresenter() {
        return (
            <div className="ItemSubContainer">
                <SelectField
                        className="ItemSubSelector"
                        id="courseItemSelector"
                        label="Course Name"
                        placeholder="Select Course"
                        required={true}
                        helpText="Select the course you want to target"
                        menuItems={
                            this.props.model.coursesAppSections
                            .filter(
                                item => (
                                    isNullOrUndefined(item.ageGroups) ||
                                    item.ageGroups.length === 0 ||
                                    item
                                .ageGroups
                                .indexOf(this.props.model.selectedRole.age_group) > -1 
                                )
                            ).map(
                                notificaitonItem => {
                                    return {
                                        label: notificaitonItem.label,
                                        value: notificaitonItem.code
                                    };
                                }
                            )
                        }
                        value={this.props.model.selectedCourseCode}
                        onChange={(value) => this.props.model.selectedCourseCode = value.toString()}
                />
                {
                    (!isNullOrUndefined(this.props.model.selectedCourseCode) &&
                    this.props.model
                    .coursesAppSections
                    .findIndex(item => item.code === this.props.model.selectedCourseCode) > -1) &&
                    <SelectField
                        className="ItemSubSelector"
                        id="moduleItemSelector"
                        label="Module Name"
                        placeholder="Select Module"
                        required={true}
                        helpText="Select the module you want to target"
                        menuItems={
                            this.props.model
                            .coursesAppSections.find(item => item.code === this.props.model.selectedCourseCode)
                            .courseModules
                            .map(
                                notificaitonItem => {
                                    return {
                                        label: notificaitonItem.label,
                                        value: notificaitonItem.label
                                    };
                                }
                            )
                        }
                        value={this.props.model.selectedModuleName}
                        onChange={(value) => this.props.model.selectedModuleName = value.toString()}
                    />
                }
                {
                    (!isNullOrUndefined(this.props.model.selectedModuleName) &&
                    this.props.model
                    .coursesAppSections
                    .find(item => item.code === this.props.model.selectedCourseCode)
                    .courseModules.findIndex(item => item.label === this.props.model.selectedModuleName) > -1 ) &&
                    !isNullOrUndefined(this.props.model
                    .coursesAppSections
                    .find(item => item.code === this.props.model.selectedCourseCode)
                    .courseModules.find(item => item.label === this.props.model.selectedModuleName).pages) &&
                    this.props.model
                    .coursesAppSections
                    .find(item => item.code === this.props.model.selectedCourseCode)
                    .courseModules.find(item => item.label === this.props.model.selectedModuleName)
                    .pages.length !== 0 &&
                    <SelectField
                        className="ItemSubSelector"
                        id="pageItemSelector"
                        label="Page Title"
                        placeholder="Select Page"
                        required={true}
                        helpText="Select the page you want to target"
                        menuItems={
                            this.props.model
                            .coursesAppSections
                            .find(item => item.code === this.props.model.selectedCourseCode)
                            .courseModules.find(item => item.label === this.props.model.selectedModuleName)
                            .pages
                            .map(
                                notificaitonItem => {
                                    return {
                                        label: notificaitonItem.label,
                                        value: notificaitonItem.label
                                    };
                                }
                            )
                        }
                        value={this.props.model.selectedPageName}
                        onChange={(value) => this.props.model.selectedPageName = value.toString()}
                    />
                }
                {
                    (!isNullOrUndefined(this.props.model.selectedModuleName) &&
                    this.props.model
                    .coursesAppSections
                    .find(item => item.code === this.props.model.selectedCourseCode)
                    .courseModules.findIndex(item => item.label === this.props.model.selectedModuleName) > -1 ) &&
                    (isNullOrUndefined(this.props.model
                    .coursesAppSections
                    .find(item => item.code === this.props.model.selectedCourseCode)
                    .courseModules.find(item => item.label === this.props.model.selectedModuleName).pages) ||
                    this.props.model
                    .coursesAppSections
                    .find(item => item.code === this.props.model.selectedCourseCode)
                    .courseModules.find(item => item.label === this.props.model.selectedModuleName)
                    .pages.length === 0 ) &&
                    <TextField
                                    key={`page-name-input`}
                                    id="pageNameInput"
                                    helpText="Course Page Name"
                                    fullWidth={false}
                                    label="Page Name"
                                    type="text" 
                                    onChange={(e) => this.props.model.selectedPageName = e.toString()}
                                    value={this.props.model.selectedPageName}
                    />

                }
            </div>
        );
    }
    testbasedAppUrlsPresenter() {
        let selectedItems: TestingAppUrlItem[]; 
        if (this.props.model.selectedSection === "Module Quiz") {
            selectedItems = this.props.model.quizgAppSections;
        } else if (this.props.model.selectedSection === "Module Test") {
            selectedItems = this.props.model.testingAppSections;
        }
        return (
            <div className="ItemSubContainer">
                <SelectField
                        id="courseTestItemSelector"
                        className="ItemSubSelector"
                        label="Course Name"
                        placeholder="Select Course"
                        required={true}
                        helpText="Select the course you want to target"
                        menuItems={
                            selectedItems
                            .filter(
                                item => (
                                    isNullOrUndefined(item.ageGroups) ||
                                    item.ageGroups.length === 0 ||
                                    item
                                .ageGroups
                                .indexOf(this.props.model.selectedRole.age_group) > -1 
                                )
                            ).map(
                                notificaitonItem => {
                                    return {
                                        label: notificaitonItem.label,
                                        value: notificaitonItem.label
                                    };
                                }
                            )
                        }
                        value={this.props.model.selectedTestCourse}
                        onChange={(value) => this.props.model.selectedTestCourse = value.toString()}
                />
                {
                    (!isNullOrUndefined(this.props.model.selectedTestCourse) &&
                    selectedItems.findIndex(item => item.label === this.props.model.selectedTestCourse) > -1) &&
                    <SelectField
                        id="moduleTestItemSelector"
                        label="Module Name"
                        className="ItemSubSelector"
                        placeholder="Select Module"
                        required={true}
                        menuItems={
                            selectedItems
                            .find(item => item.label === this.props.model.selectedTestCourse)
                            .modules
                            .map(
                                notificaitonItem => {
                                    return {
                                        label: notificaitonItem.label,
                                        value: notificaitonItem.label
                                    };
                                }
                            )
                        }
                        value={this.props.model.selectedTestModule}
                        onChange={(value) => this.props.model.selectedTestModule = value.toString()}
                    />

                }
            </div>
        );
    }
    render() {
        return(
            <div>
            {
                !isNullOrUndefined(this.props.model) &&
                <DialogContainer
                    id="simple-full-page-dialog"
                    visible={this.props.model.showDialog}
                    pageX={this.props.model.pageX}
                    pageY={this.props.model.pageY}
                    fullPage={true}
                    onHide={() => {this.props.model.onComplete(undefined); }}
                    aria-labelledby="simple-full-page-dialog-title"
                >
                <Toolbar
                    fixed={true}
                    colored={true}
                    title="Create Notification"
                    titleId="simple-full-page-dialog-title"
                    nav={<Button icon={true} onClick={() => {this.props.model.onComplete(undefined); }}>close</Button>}
                    actions={
                    <Button 
                        flat={true} 
                        onClick={this.props.model.onDoneClicked}
                    >
                    {this.props.model.sendLaterEnabled ? "Save" : "Send"}
                    </Button>}
                />
                {
                    !isNullOrUndefined(this.props.model.organisation) &&
                    
                <section className="md-toolbar-relative">
                    <div className="CreateNotificationPaperContainer">
                        {
                            this.props.model.errorMessages.length > 0 &&
                            <Card className="messagesCard">
                                <CardText className="messageText">
                                    {
                                        this.props.model.errorMessages.map(
                                            (item, index) => {
                                                return <p key={index}>{item}</p>;
                                            }
                                        )
                                    }
                                </CardText>
                            </Card>

                        }
                    <div> 
                    { 
                        this.props.model.organisation.code === "SSPINQ" &&
                        <div className="CreateNotificationPaperContainer">
                            <h5> Target Audience </h5>
                            <Paper
                                className="CreateNotificationPaper"
                                zDepth={2}
                                raiseOnHover={false}
                            >
                                <p> 
                                The notification will be sent to users who have notifications 
                                enabled and meet the following conditions:    
                                </p>
                                <div className="NotificationItemContainer">
                                    <div className="ItemSubContainer">
                                        <Radio 
                                            id="sendIneqeStaff" 
                                            name="sendIneqeStaff" 
                                            label="Send To Ineqe Staff Only" 
                                            value="sendIneqeStaff"
                                            checked={!this.props.model.sendToAllOrganisations}
                                            onChange={() => this.props.model.sendToAllOrganisations = false}
                                        />
                                        <Radio 
                                            id="sendAll" 
                                            name="sendAll" 
                                            label="Send To All Organisations" 
                                            value="sendAll"
                                            checked={this.props.model.sendToAllOrganisations}
                                            onChange={() => this.props.model.sendToAllOrganisations = true}
                                        />
                                    </div>
                                </div>
                            </Paper>
                            <br/>
                        </div>
                    }
                    </div>
                        <h5> 1. Recipients </h5>
                        <Paper
                            className="CreateNotificationPaper"
                            zDepth={2}
                            raiseOnHover={false}
                        >
                        <p> 
                        The notification will be sent to users who have notifications 
                        enabled and meet the following conditions:    
                        </p>
                        <div className="NotificationItemContainer">
                            <h5>Audience</h5>
                            <div className="ItemSubContainer">
                            <Radio 
                                id="everyone" 
                                name="everyone" 
                                label="Everyone" 
                                value="everyone"
                                onClick={() => this.props.model.onAudienceSelected("everyone")} 
                                checked={!this.props.model.withSelectedRole}
                            />

                            {
                                !isNullOrUndefined(this.props.model.roles) &&
                                this.props.model.roles.length > 0 &&
                                <Radio 
                                    id="roles" 
                                    name="roles" 
                                    value="roles"
                                    label="Selected Roles" 
                                    onClick={() => this.props.model.onAudienceSelected("roles")} 
                                    checked={this.props.model.withSelectedRole} 
                                />
                            }
                            </div>
                            <div className="RecipientsHiddenContainer">
                            {
                                this.props.model.withSelectedRole &&
                                <div>
                                    <h5>Roles</h5>
                                    <div className="ItemSubContainer">
                                    {
                                        this.props.model.roles.map(
                                            (role, index) => {
                                                return (
                                                    <Radio 
                                                        key={index}
                                                        id={role.name}
                                                        name={role.name}
                                                        value={role.name}
                                                        label={role.name}
                                                        checked={!isNullOrUndefined(this.props.model.selectedRole)
                                                            && this.props.model.selectedRole.name === role.name}
                                                        onChange={(e) => {this.props.model.onRoleSelected(role.name); }}
                                                    />
                                                );
                                            }
                                        )
                                    }
                                    </div>
                                </div>
                            }
                            {
                                this.props.model.withSelectedRole &&
                                !isNullOrUndefined(this.props.model.groups) &&
                                this.props.model.groups.length > 0 &&
                                <div>
                                    <h5>with groups</h5>
                                    <div className="ItemSubContainer">
                                    {
                                        this.props.model.groups.map(
                                            (group, index) => {
                                                return (
                                                    <Checkbox 
                                                        key={index}
                                                        id={`${group.name}_${index}`}
                                                        name={`${group.name}_${index}`}
                                                        label={group.name}
                                                        checked={
                                                            !isNullOrUndefined(
                                                                this.props.model.selectedGroups
                                                                .find(item => item.name === 
                                                                group.name)
                                                            )
                                                        }
                                                        onChange={(e) => {this.props.model.onGroupSelected(group.name); 
                                                                        }}
                                                    />
                                                );
                                            }
                                        )
                                    }
                                    </div>
                                </div>
                                }
                            </div>
                        </div>

                        </Paper>
                    </div>

                    <div className="CreateNotificationPaperContainer">
                    <h5> 2. Notification </h5>

                    <Paper
                        className="CreateNotificationPaper"
                        zDepth={2}
                        raiseOnHover={false}
                    >
                    <p>
                    A notification is designed to display a small amount of text.
                    The limits vary between platforms and depending upon where it is displayed. 
                    A notification displayed in Notification Center on iOS gets truncated 
                    to around 110 characters or 4 lines.
                    </p>

                    <TextField
                        id="floating-label-counter-field"
                        label="Notification Title"
                        placeholder=""
                        maxLength={40}
                        className="md-cell md-cell--bottom"
                        // tslint:disable-next-line:max-line-length
                        helpText="A short string describing the purpose of the notification. This is not displayed on all devices"
                        value={this.props.model.notificationTitle}
                        onChange={ (value) => {
                            this.props.model.notificationTitle = value.toString();
                        } }
                    />
                    <TextField
                        id="multiline-counter-field"
                        label="Notification Body"
                        // tslint:disable-next-line:max-line-length
                        helpText="The text of the alert message. This should be standalone so that it is meaningful when presented without the title."
                        required={true}
                        placeholder=""
                        rows={2}
                        maxLength={200}
                        className="md-cell md-cell--bottom"
                        value={this.props.model.notificationBody}
                        onChange={ (value) => {
                            this.props.model.notificationBody = value.toString();
                        } }
                    />
                    </Paper>
                    </div>

                    <div className="CreateNotificationPaperContainer">
                        <h5> 3. App URL </h5>
                        <Paper
                            className="CreateNotificationPaper"
                            zDepth={2}
                            raiseOnHover={false}
                        >
                        <p>
                        Select what you want the user to see when the notification is clicked
                        </p>
                        <div className="NotificationItemContainer">
                        <Radio 
                            id="homePage"
                            name="Home Page"
                            label="Home Page" 
                            value="Home Page"
                            checked={this.props.model.selectedSection === "Home Page"}
                            onChange={() => this.props.model.selectedSection = "Home Page"}
                        />
                        {
                            !isNullOrUndefined(this.props.model.generalAppSections) &&
                            this.props.model.generalAppSections
                            .map(
                                (section, index) => {
                                    let itemLength = this.props.model.generalAppSections[index].items.length; 
                                    if (itemLength > 0) {
                                        return  <Radio 
                                            key={`${section.name.replace(new RegExp(" ", "g"), "")}_${index}`}
                                            id={`${section.name.replace(new RegExp(" ", "g"), "")}_${index}`}
                                            name={section.name}
                                            label={section.name} 
                                            value={section.name}
                                            checked={this.props.model.selectedSection === section.name}
                                            onChange={() => {
                                                this.props.model.selectedAppUrl = undefined;
                                                this.props.model.selectedSection = section.name;
                                            }
                                            }
                                            // tslint:disable-next-line:jsx-alignment
                                            />;
                                        }
                                        
                                }
                            )
                        }
                        {
                            !isNullOrUndefined(this.props.model.coursesAppSections) &&
                                <Radio 
                                    disabled={!this.props.model.withSelectedRole 
                                        || isNullOrUndefined(this.props.model.selectedRole)}
                                    id="coursePage"
                                    name="Course Page"
                                    label="Course Page" 
                                    value="Course Page"
                                    checked={this.props.model.selectedSection === "Course Page"}
                                    onChange={() => {
                                        this.props.model.selectedAppUrl = undefined;
                                        this.props.model.selectedSection = "Course Page";
                                    }
                                    }
                                />
                        }
                        {
                            !isNullOrUndefined(this.props.model.testingAppSections) &&
                                this.props.model.testingAppSections.length > 0 &&
                                <Radio 
                                    disabled={!this.props.model.withSelectedRole
                                        || isNullOrUndefined(this.props.model.selectedRole)}
                                    id="moduleTest"
                                    name="moduleTest"
                                    label="Module Test" 
                                    value="Module Test"
                                    checked={this.props.model.selectedSection === "Module Test"}
                                    onChange={() => {
                                        this.props.model.selectedAppUrl = undefined;    
                                        this.props.model.selectedSection = "Module Test";
                                        }
                                    }
                                />
                        }
                        {
                            !isNullOrUndefined(this.props.model.quizgAppSections) &&
                                this.props.model.quizgAppSections.length > 0 &&
                                <Radio 
                                    disabled={!this.props.model.withSelectedRole
                                        || isNullOrUndefined(this.props.model.selectedRole)}
                                    id="moduleQuiz"
                                    name="moduleQuiz"
                                    label="Module Quiz" 
                                    value="Module Quiz"
                                    checked={this.props.model.selectedSection === "Module Quiz"}
                                    onChange={() => {
                                        this.props.model.selectedAppUrl = undefined;
                                        this.props.model.selectedSection = "Module Quiz";
                                        }
                                    }
                                />
                        }
                        </div>
                        {
                            (!isNullOrUndefined(this.props.model.generalAppSections) &&
                            this.props.model.generalAppSections.map(item => item.name)
                            .indexOf(this.props.model.selectedSection) > -1 ) &&
                            this.generalAppUrlsPresenter()
                        }
                        {
                            (!isNullOrUndefined(this.props.model.coursesAppSections) &&
                            this.props.model.selectedSection === "Course Page") &&
                            this.coursesAppUrlsPresenter()
                        }
                        {
                            (
                                (this.props.model.selectedSection === "Module Quiz" &&
                                !isNullOrUndefined(this.props.model.quizgAppSections)
                                ) 
                                || 
                                (this.props.model.selectedSection === "Module Test" &&
                                !isNullOrUndefined(this.props.model.testingAppSections))     
                            ) &&
                            this.testbasedAppUrlsPresenter()
                        }
                        </Paper>
                    </div>

                    <div className="CreateNotificationPaperContainer">
                        <h5> 4. Scheduling </h5>

                        <Paper
                            className="CreateNotificationPaper"
                            zDepth={2}
                            raiseOnHover={false}
                        >
                        <div className="NotificationItemContainer">
                        <div className="ItemSubContainer">
                        <Radio 
                            id="sendNow" 
                            name="sendNow" 
                            label="Send Now" 
                            value="sendNow"
                            checked={!this.props.model.sendLaterEnabled}
                            onChange={() => this.props.model.sendLaterEnabled = false}
                        />
                        <Radio 
                            id="sendLater" 
                            name="sendLater" 
                            label="Send Later" 
                            value="sendLater"
                            checked={this.props.model.sendLaterEnabled}
                            onChange={() => this.props.model.sendLaterEnabled = true}
                        />
                        </div>
                        </div>
                        {
                            this.props.model.sendLaterEnabled && 
                            <div className='NotificationTimeContainer'>
                                <div className="NotificationDate">
                                    <h5>Date</h5>
                                    <DatePicker
                                        id="appointment-date-portrait"
                                        label="Date"
                                        className="md-cell"
                                        displayMode="portrait"
                                        onChange={(date) => this.props.model.selectedDate = date}
                                    />                            
                                </div>
                                <div className="NotificationTime">
                                    <h5>Time</h5>
                                    <TimePicker
                                        id="appointment-time-portrait"
                                        label="Time"
                                        className="md-cell"
                                        displayMode="portrait"
                                        onChange={(time) => this.props.model.selectedTime = time}
                                    />                            
                                </div>

                            </div>
                        }
                            
                        </Paper>
                    </div>
                    <div className="NotificationSubmitContainer">
                        <Button 
                            flat={true}
                            secondary={true}
                            swapTheming={true} 
                            disabled={this.props.model.sendDisabled}
                            onClick={this.props.model.onDoneClicked}
                            className='NotificationSubmit'
                        >
                        {this.props.model.sendLaterEnabled ? "Save" : "Send"}
                        </Button>
                        {
                            this.props.model.errorMessages.length > 0 &&
                            <Card className="messagesCard">
                                <CardText className="messageText">
                                    {
                                        this.props.model.errorMessages.map(
                                            (item, index) => {
                                                return <p key={index}>{item}</p>;
                                            }
                                        )
                                    }
                                </CardText>
                            </Card>

                        }                
                    </div>

                    <div className="CreateNotificationPaper">
                    <p>
                    Notification delivery depends upon whether the user allows their device to display notifications.
                    While the App can encourage the user to enable them it cannot force them.
                    </p>
                    <p>
                    If an iOS device is offline, often only the most recent notification is later delivered by Apple.
                    Please plan the text and the timing of your notifications accordingly.
                    </p>
                    <p>
                    To continue to 
                    receive full notification support users must install App updates and occasionally open the App.
                    </p>
                </div>
                </section>
                
                }
                
                </DialogContainer>
            }
            </div>
        );
    }
}

export default SendPushNotificationsDialog;


// WEBPACK FOOTER //
// ./src/view/Admin/PushNotifications/SendPushNotificationDialog/SendPushNotificationDialog.tsx